import React, { useState, useEffect, useCallback } from "react";
import { Grid, Typography, IconButton, Tooltip } from "@material-ui/core/";
import { Folder, Description, RemoveCircle } from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Alert from "react-s-alert";
/********** COMPONENTS **********/
import ConfirmationElement from "component/ConfirmationElement";
import LoadingSpinner from "component/LoadingSpinner";
import AlertElement from "component/AlertElement";
import FoilDetail from "../FoilDetail";
import Title from "component/Title";
import Table from "component/Table";
/********** SERVICES **********/
import ApiServices from "service/ApiServices";
/********** STYLES **********/
import { useStyles } from "./style";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  /********** VARIABLES **********/
  const classes = useStyles();
  const { name, id } = props.data;
  const titlePackage = id + (name ? " - " + name : "");
  const controllerPackage = "paquetesDeAfiliacionYAdhesion";
  const controllerSheets = "hojasAfiliacionYAdhesion";

  const [elementAlertModal, setElementAlertModal] = useState({
      titleAlert: "",
      typeAlert: "",
    }),
    [loadingSpinner, setLoadingSpinner] = useState({
      openLoading: false,
      message: "",
    }),
    [openDetailFoilModal, setOpenDetailFoilModal] = useState(false),
    [openDeleteModal, setOpenDeleteModal] = useState(false),
    [openAlertModal, setOpenAlertModal] = useState(false),
    [dataDetailFoil, setDataDetailFoil] = useState([]),
    [idDetailFoil, setIdDetailFoil] = useState(""),
    [idFoil, setIdFoil] = useState(""),
   [data, setData] = useState([]),
    [tableHeader] = useState([
      {
        title: "Identificador del paquete",
        field: "idPaquete",
        cellStyle: { width: "100px", height: "50px" },
      },
      {
        title: "Correlativo de hoja",
        field: "correlativo",
        cellStyle: { width: "150px", height: "50px" },
      },
      {
        title: "Afiliados ingresados",
        field: "totalAfiliados",
        render: (rowData) => <p>{rowData.totalAfiliados} / 5</p>,
      },
      {
        title: "Estado",
        field: "estado",
        render: () => (
          <div style={{ minWidth: "200px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Folder style={{ color: "#5dade2" }} /> EN PAQUETE
            </div>
          </div>
        ),
      },
      {
        title: "Acciones",
        field: "acciones",
        render: (rowData) => (
          <div
            className={classes.actionContainer}
            style={{ minWidth: "200px" }}
          >
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Detalle de hoja"
                onClick={() => handleOpenDetailFoil(rowData)}
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="primary"
                >
                  <Description />
                </IconButton>
              </Tooltip>
            </div>
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Remover"
                onClick={() => handleOpenDeleteModal(rowData)}
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="secondary"
                >
                  <RemoveCircle />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ]);

  /********** FUNCTIONS **********/
  /* Función para obtener todas las hojas dentro de un paquete mediante su ID */
  const showList = useCallback(async () => {
    try {
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: true,
        message: "Obteniendo detalle del paquete...",
      });
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controllerPackage,
        "list"
      );
      if (hasPermission.error) {
        Alert.warning("Permisos insuficientes, consulte con soporte");
        setLoadingSpinner({ ...loadingSpinner, openLoading: false });
      } else {
        let response = await ApiServices[controllerPackage].getDetailPackageOp(
          id
        );
        if (response.error !== null) {
          setOpenAlertModal(true);
          setElementAlertModal({
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          setData(response.data);
        }
        setLoadingSpinner({ ...loadingSpinner, openLoading: false });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    }
  }, []);

  useEffect(() => {
    showList();
  }, [showList]);

  /*  El método despliega el modal "FoilDetail" se ejecuta desde el botón "Detalle de hoja" de cada fila de la hoja en la tabla */
  const handleOpenDetailFoil = (rowData) => {
    setDataDetailFoil(rowData);
    setOpenDetailFoilModal(true);
  };

  /*  Este método cierra el modal "FoilDetail", se ejecuta desde el botón  "Cerrar" de este mismo modal */
  const handleCloseDetailFoil = () => {
    setOpenDetailFoilModal(false);
  };

  /*  Este método nos despliega el "ConfirmationElement" para confirmar que se removera una hoja del paquete, se ejecuta desde
      el botón "Remover" */
  const handleOpenDeleteModal = (rowData) => {
    setIdDetailFoil(rowData.idDetallePaquete);
    setIdFoil(Number(rowData.idHoja));
    setOpenDeleteModal(true);
  };

  /*  El método cierra el "ConfirmationElement", se ejecuta desde el botón "Cancelar" de este mismo modal */
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  /*  El método elimina la hoja que hayamos elegido, se ejecuta desde el "ConfirmationElement" en el botón
      "Confirmar", si todo se ejecuta correctamente cierra el modal para actualizar la información */
  const removeFoilPackage = async () => {
    setLoadingSpinner({
      ...loadingSpinner,
      openLoading: true,
      message: "Removiendo hoja del paquete...",
    });
    try {
      handleCloseDeleteModal();
      let response = await ApiServices[controllerSheets].eliminarHojadePaquete(
        idDetailFoil,
        idFoil
      );
      if (response.error !== null) {
        setOpenAlertModal(true);
        setElementAlertModal({
          titleAlert: response.error.message,
          typeAlert: "error",
        });
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false
              });
      } else {
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false
              });
        props.updateModal();
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false
      });
    }
  };

  /* Este método cierra el modal "AlertElement" de mensajes de alerta */
  const handleCloseAlertModal = () => {
    setOpenAlertModal(false);
  };

  /*  Este método cierra el modal actual, se ejecuta desde el bóton "Cerrar" o al presionar fuera del modal */
  const closeModal = () => {
    props.handCloseModal();
  };

  /********** RENDER **********/
  return (
    <div>
      <Dialog
        open={props.open}
        maxWidth={"xl"}
        fullWidth={true}
        fullScreen={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {loadingSpinner.openLoading && (
          <LoadingSpinner
            open={loadingSpinner.openLoading}
            message={loadingSpinner.message}
          />
        )}
        {openDetailFoilModal && (
          <FoilDetail
            open={openDetailFoilModal}
            handCloseModal={handleCloseDetailFoil}
            data={dataDetailFoil}
          />
        )}
        {openDeleteModal && (
          <ConfirmationElement
            open={openDeleteModal}
            handleClose={handleCloseDeleteModal}
            handleConfirm={removeFoilPackage}
            titleModal="¿Quiere remover la hoja del paquete?"
            subtitleModal={
              'Esta acción no eliminará la hoja y su información, podrá encontrarla en la pestaña "Crear Paquete".'
            }
          />
        )}
        <Title title={"Detalle de las hojas en el paquete " + titlePackage} />
        <div className={classes.root}>
          <div className={classes.colorComponente}>
            <Grid container>
              <Grid
                item
                xs={12}
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.formTitle}
              >
                <Typography
                  component="span"
                  variant="body1"
                  color="textPrimary"
                >
                  <br />
                  <strong>
                    Si desea remover una hoja del paquete de click en el botón
                    "Remover". La hoja no será eliminada, podrá encontrarla en
                    la pestaña "Crear Paquete"
                  </strong>
                  <br />
                  <br />
                  <br />
                </Typography>
              </Grid>
              <Grid className={classes.AlignTable} item xs={12}>
                <Table
                  title={"Listado de hojas"}
                  header={tableHeader}
                  data={data}
                  goBack={closeModal}
                />
              </Grid>
            </Grid>
            <br />
            <div className={classes.lineaDegradadaBottom}></div>
          </div>
          <br />
        </div>
        <AlertElement
          typeAlert={elementAlertModal.typeAlert}
          openModal={openAlertModal}
          title={elementAlertModal.titleAlert}
          handCloseModal={handleCloseAlertModal}
        />
      </Dialog>
    </div>
  );
}
